'use client';

import { allowedCharsLabel, charsLeftLabel } from "../Textarea.data.js";
const getMaxCharactersA11yMessage = (maxCharacters, valueLength) => {
  if (valueLength === 0) return allowedCharsLabel(maxCharacters);
  return charsLeftLabel(maxCharacters - valueLength);
};
export {
  getMaxCharactersA11yMessage
};
